/** Shorten a string while retaining the requested number of characters at each end. */
export function truncateHash(value: string, first = 4, last = 6): string {
  if (!Number.isInteger(first) || first < 0 || !Number.isInteger(last) || last < 0) {
    throw new RangeError("first and last must be non-negative integers");
  }

  if (value.length <= first + last + 3) return value;

  return `${value.slice(0, first)}...${last === 0 ? "" : value.slice(-last)}`;
}
